import { IApplicationState } from '../../types/redux';

export const selectShortFormRedirectUrl = (state: IApplicationState): string | null =>
  state.calculator.shortFormRedirectUrl;
